/* eslint-disable no-magic-numbers */
import React from 'react';
import PropTypes from 'prop-types';
import css from '../cards/SellerCard.APP_TARGET.scss';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { isMobile } from 'Helpers/devices';
import classnames from 'classnames';

export const OperatingDetails = ({
    currentOpenState,
    operatingDetailsObject,
    isOpen
}) => {
    return (
        <div style={ { flexDirection: 'column' } }>
            <div className={ css.timingDetails }>
                <div className={ css.operatingBox }>
                    <div data-aut-id="curr-open-state" className={ classnames({ [css.open]: !!isOpen, [css.close]: !isOpen }) }>{currentOpenState}</div>
                </div>
            </div>

            { Object.keys(operatingDetailsObject).map((key, i) => (
                <div className={ css.timingDetails } key={ `operatingDetails-${key}-${i}` }>
                    <div className={ css.icon }>
                        <Icon icon="clock" size={ isMobile ? 16 : 36 } color="primary" />
                    </div>
                    <div className={ css.operatingBox }>
                        <div className={ css.daysTimings }>
                            <span className={ css.timings }>{operatingDetailsObject[key][0].operatingTime}</span>
                            <span style={ { margin: '0 8px' } }>|</span>
                            {operatingDetailsObject[key].map((operatingItem, j, arr) => (

                                <span key={ `operatingItem-${key}-${j}` }>
                                    { operatingItem.shortWeekDay }
                                    { ((j + 1) < arr.length) && ', ' }
                                </span>

                            ))}
                        </div>
                    </div>
                </div>
            )) }
        </div>
    );
};

OperatingDetails.propTypes = {
    currentOpenState: PropTypes.string,
    operatingDetailsObject: PropTypes.object,
    isOpen: PropTypes.bool
};

OperatingDetails.defaultProps = {
    currentOpenState: '',
    operatingDetailsObject: {},
    isOpen: false
};

export default React.memo(OperatingDetails);
